// extracted by mini-css-extract-plugin
export default {"box":"Layout_box__16a23","row":"Layout_row__XIbhR","header":"Layout_header__2LDzi","content":"Layout_content__88Srk","footer":"Layout_footer__UuEGB","page":"Layout_page__n2qJl"};